import thunk from 'redux-thunk';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import defaultState from './defaultState.js';
import reducer from './reducer.js';
import { gtmMiddleware } from './gtm.js';

const middleware = [gtmMiddleware, thunk];

const store = createStore(reducer, defaultState, composeWithDevTools(applyMiddleware(...middleware)));

export default store;
